import { combineReducers } from "redux";
import authSlice from "./Slice/auth.slice";
import userSlice from "./Slice/user.slice";
import categorySlice from "./Slice/category.slice";
import contactSlice from "./Slice/contactUs.slice";
import TermsSlice from "./Slice/TermsCondition.slice";
import policySlice from "./Slice/PrivacyPolicy.slice";
import dashboardSlice from "./Slice/dashboard.slice";
import paymentSlice from './Slice/Payment.slice';
import gameReducer from './Slice/game.slice';
import cartReducer from './Slice/cart.slice';
import wishlistReducer from './Slice/wishlist.slice';
import blogReducer from './Slice/blog.slice';
import blogReviewReducer from './Slice/blogReview.slice';
import faqSlice from './Slice/faq.slice';
import subscribeSlice from './Slice/subscribe.slice';
import ratingSlice from './Slice/rating.slice';
import aboutSlice from './Slice/about.slice';
import recentlyViewedReducer from './Slice/recentlyViewed.slice';
import discountSlice from './Slice/discount.slice';
import bundleSlice from './Slice/bundle.slice';

export const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  contactUs: contactSlice,
  category: categorySlice,
  term: TermsSlice,
  policy: policySlice,
  dashboard: dashboardSlice,
  payment: paymentSlice,
  game: gameReducer,
  cart: cartReducer,
  wishlist: wishlistReducer,
  blog: blogReducer,
  blogReview: blogReviewReducer,
  faq: faqSlice,
  subscribe: subscribeSlice,
  rating: ratingSlice,
  about: aboutSlice,
  recentlyViewed: recentlyViewedReducer,
  discount: discountSlice,
  bundle: bundleSlice
});

